import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { userKeys } from '../../cache-keys/userKeys';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { lock_api } from '@axo/shared/data-access/api';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function useUnlockApplications(marketCountry: string) {
  const { state } = useContext(DataAccessContext);
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    (ids: string[]) => Promise.all(ids.map((id) => lock_api.unlock(api)(id))),
    {
      onSuccess: (_, variables) =>
        Promise.all([
          client.invalidateQueries(
            userKeys.lockedApplications({
              user: state.user.clientID,
              country: marketCountry,
            })
          ),
          ...variables.map((applicationID) =>
            client.invalidateQueries(
              applicationKeys.locks({
                applicationID,
              })
            )
          ),
        ]),
    }
  );
}
